import { requestsClient } from '@/shared/api';

import {
  IBankDetailsQueryParams,
  IVabsTotalBalanceQueryParams,
  IVabsVirtualBalancesQueryParams,
} from './types';

export const bankDetailsQuery = async ({
  accId,
  currencyIds,
}: IBankDetailsQueryParams) => {
  const { vabsAccMyBankDetails } = await requestsClient.vabsAccMyBankDetails({
    input: { virtualAccountId: accId, currencyIds: currencyIds },
  });

  return vabsAccMyBankDetails;
};

export const vabsCurrenciesQuery = async () => {
  const { currencies } = await requestsClient.vabsCurrencies();
  return currencies;
};

export const vabsAccountsQuery = async (skip: number) => {
  const { vabsAccMyVirtualAccounts } =
    await requestsClient.vabsAccMyVirtualAccounts({
      input: {},
      balancesInput: { pagination: { skip } },
    });

  return vabsAccMyVirtualAccounts;
};

export const vabsVirtualBalancesQuery = async ({
  virtualAccountId,
  skip,
}: IVabsVirtualBalancesQueryParams) => {
  const { vabsAccMyVirtualBalances } =
    await requestsClient.vabsAccMyVirtualBalances({
      accMyVirtualBalancesInput: {
        virtualAccountId,
        // pagination: { skip },
      },
    });
  return vabsAccMyVirtualBalances;
};

export const totalBalanceQuery = async ({
  virtualAccountId,
  currencyId = '',
}: IVabsTotalBalanceQueryParams) => {
  const { vabsMyTotalBalance } = await requestsClient.vabsMyTotalBalance({
    currencyId,
    virtualAccountId,
  });
  return vabsMyTotalBalance;
};
